module.exports = __webpack_public_path__ + "i18n/pl.a450fad2143346314fdc32a837379ede.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/pl.json
// module id = 1063
// module chunks = 60